module.exports = __webpack_public_path__ + "10_mustache_silver.7dc4ff12.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/10_mustache_silver.png
// module id = dfLT
// module chunks = 0